// extracted by mini-css-extract-plugin
export default {"container":"FFOO9C69jZxyAV9xg42T","small":"MSLtjFbtVteW5ghLHnSn"};